// Your account (/account), where logging in lands: your place on the waitlist. With a GG Bharat name claimed, its pass
// (founder number, registered or reserved); without one, the way to claim it. Your details, what happens next, and
// logging out. The games aren't open: nothing here leads into one.
import { useEffect } from 'react';
import { logOut, useAccount } from './account';
import { PASS, REG } from './brand';
import { SiteFooter, SiteNav } from './Chrome';
import { Pass } from './Pass';
import { openRegister } from './Register';
import { linkProps, navigate } from './router';
import './home.css';

export function Account() {
  const me = useAccount();
  useEffect(() => {
    if (me === null) navigate('/login?next=%2Faccount', true);
  }, [me]);
  if (!me) return <div className="gx kz" aria-busy="true" />;
  const c = me.claim;
  return (
    <div className="gx kz">
      <div className="kz-grain" aria-hidden />
      <SiteNav />
      <main className="ac">
        <section className="ac-head">
          <p className="gx-kicker mono">
            <i className="live" /> Your account · on the waitlist
          </p>
          <h1>
            Namaste,
            <br />
            <em>@{me.displayName}.</em>
          </h1>
          <p className="dim">
            {c
              ? 'Your GG Bharat name is yours, and you’re a founder: founders get in first when Chandigarh opens. We’ll email you the day.'
              : 'You’re on the waitlist for Chandigarh: The City Beautiful. Claim your GG Bharat name to be a founder: founders get in first, and the name is yours for good.'}
          </p>
        </section>

        <section className="ac-pass">
          {c ? (
            <>
              <Pass name={c.name} founder={c.founder} size="lg" stamp={c.paid ? 'Registered' : 'Reserved'} />
              <p className="ac-note mono">{c.paid ? `Fee received · founder #${String(c.founder ?? 0).padStart(4, '0')}` : 'Reserved: we’ll email you a link to pay the ₹49 when payments open.'}</p>
            </>
          ) : (
            <>
              <Pass name="" state={null} size="lg" stamp="Not claimed" />
              <button type="button" className="gx-btn lg" onClick={() => openRegister()}>
                Join the waitlist · ₹{REG.fee} <span aria-hidden>→</span>
              </button>
              <p className="ac-note mono">One name a person · taxes included · {REG.refundDays}-day refund</p>
            </>
          )}
        </section>

        <section className="ac-cards">
          <div className="ac-card">
            <h2>Your details</h2>
            <dl>
              <div>
                <dt>Name</dt>
                <dd>@{me.displayName}</dd>
              </div>
              <div>
                <dt>Email</dt>
                <dd>{me.email}</dd>
              </div>
              {me.instagram && (
                <div>
                  <dt>Instagram</dt>
                  <dd>@{me.instagram}</dd>
                </div>
              )}
            </dl>
            <p className="small">Other players only ever see your name. Your email is for logging in and our emails about the launch.</p>
          </div>
          <div className="ac-card">
            <h2>What happens next</h2>
            <ol>
              <li>Chandigarh: The City Beautiful is in a closed beta.</li>
              <li>{c ? 'As a founder, you’re among the first in when it opens.' : 'Founders (with a claimed name) get in first.'}</li>
              <li>We’ll email {me.email} the day it opens. The {PASS.name} (₹{PASS.price}) goes on sale then.</li>
            </ol>
          </div>
          <div className="ac-card">
            <h2>Your login</h2>
            <p className="small">Forgot it, or want a new one? We’ll email you a link to set a new password.</p>
            <a className="gx-btn ghost" {...linkProps('/login?mode=forgot')}>
              Change password
            </a>
            <button type="button" className="gx-btn ghost" onClick={() => void logOut().then(() => navigate('/'))}>
              Log out
            </button>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
